import { createFileRoute } from '@tanstack/react-router'
import NotFoundPage from '@web/src/features/not-found/not-found'
import { test404PageHeadFromLoaderData } from './404.seo'

export const Route = createFileRoute('/(public)/test/404')({
  component: RouteComponent,
  head: () => test404PageHeadFromLoaderData(),
})

function RouteComponent() {
  return <NotFoundPage />
}
